import {put, takeLatest, call} from 'redux-saga/effects';
import * as orderService from "../../../services/orderService";
import {
    APPROVE_ORDER,
    APPROVE_ORDER_SUCCESS,
    APPROVE_ORDER_ERROR,
}
    from "../../actions/order";

function* approveOrderSaga(action) {
    try {
       const data  = yield call(orderService.ApproveOrder,action.payload)
        
       yield put({
        type: APPROVE_ORDER_SUCCESS,
        payload: data
    });


    } catch (error) {
        yield put({
            type: APPROVE_ORDER_ERROR,error: error.data
        });
    }
}


export function* approveOrderSagaWatcher() {
    yield takeLatest(APPROVE_ORDER, approveOrderSaga);
}